<template>
  <div class="relative min-h-screen w-full overflow-hidden">
    <!-- Two-tone Background -->
    <div class="absolute inset-0">
      <!-- Top Section - Background Image with Overlay (Banner Style) -->
      <div
        class="absolute top-0 left-0 right-0 h-[32%]"
        style="
          background-image: url('https://sejadikopi-api-v2.sejadikopi.com/storage/images/login_bg.jpg');
          background-size: cover;
          background-position: center;
        "
      >
        <div class="absolute inset-0 bg-black/60" />
      </div>

      <!-- Wave SVG -->
      <svg
        class="absolute left-0 right-0 w-full"
        style="top: 30%; height: 60px"
        viewBox="0 0 1440 120"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          fill="#000000"
          fill-opacity="0.6"
          d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
        />
      </svg>

      <!-- Bottom Section - Very Light Gray -->
      <div class="absolute bottom-0 left-0 right-0 h-[68%] bg-[#fcfbfa]" />
    </div>

    <!-- Header with Menu Button -->
    <header class="absolute top-0 left-0 right-0 z-30">
      <div class="px-6 pt-4 pb-4 flex justify-between items-center">
        <!-- Menu Button (Garis 3) -->
        <button
          ref="menuBtn"
          aria-label="Menu"
          class="p-2.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 active:scale-95 shadow-lg shadow-white/20 backdrop-blur-sm"
          @click="toggleMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5 text-white drop-shadow-md"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <line
              x1="4"
              y1="6"
              x2="20"
              y2="6"
            />
            <line
              x1="4"
              y1="12"
              x2="20"
              y2="12"
            />
            <line
              x1="4"
              y1="18"
              x2="20"
              y2="18"
            />
          </svg>
        </button>

        <!-- Language Badge -->
        <div
          class="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/20"
        >
          <span class="text-white font-semibold text-xs">ID</span>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="relative z-10 flex flex-col min-h-screen px-6 pt-16 pb-40">
      <!-- Loading State -->
      <div
        v-if="loadingStatus"
        class="flex-1 flex flex-col items-center justify-center"
      >
        <div class="flex justify-center items-center gap-2 mb-4">
          <div
            class="w-2.5 h-2.5 bg-gradient-to-r from-[#74b9ff] to-[#a29bfe] rounded-full animate-bounce shadow-lg shadow-[#74b9ff]/50"
            style="animation-delay: 0ms"
          />
          <div
            class="w-2.5 h-2.5 bg-gradient-to-r from-[#a29bfe] to-[#fd79a8] rounded-full animate-bounce shadow-lg shadow-[#a29bfe]/50"
            style="animation-delay: 150ms"
          />
          <div
            class="w-2.5 h-2.5 bg-gradient-to-r from-[#fd79a8] to-[#74b9ff] rounded-full animate-bounce shadow-lg shadow-[#fd79a8]/50"
            style="animation-delay: 300ms"
          />
        </div>
        <p class="text-sm text-[#495057]">
          Mengecek status cafe...
        </p>
      </div>

      <!-- Cafe Closed Notice - Redirecting to CafeClosed.vue -->
      <!-- (Redirect handled in checkCafeStatus method) -->

      <!-- Main Content (Open) -->
      <div
        v-else-if="!loadingStatus && isCafeOpen"
        class="flex flex-col"
      >
        <!-- Welcome Text Section (Banner Area) -->
        <div class="flex flex-col items-center text-center py-8 mb-6">
          <h1 class="text-3xl font-bold text-white mb-2 drop-shadow-lg">
            Selamat Datang
          </h1>
          <p class="text-sm text-white/90 drop-shadow-md">
            di Sejadikopi 
          </p>
        </div>

        <!-- Buttons Section (White Area) -->
        <div class="w-full max-w-md mx-auto mb-8 flex-1">
          <!-- Buttons Container with Background -->
          <div
            class="bg-gradient-to-br from-[#faf8f5] to-[#f1efe8]  rounded-[32px] p-6 shadow-sm border border-white/60"
          >
            <div class="space-y-4">
              <!-- Takeaway Button -->
              <button
                class="group w-full bg-white backdrop-blur-sm rounded-3xl shadow-md hover:shadow-lg transition-all duration-300 active:scale-[0.98] overflow-hidden border border-gray-100"
                @click="chooseTakeaway"
              >
                <div class="flex items-center gap-4 p-5">
                  <div
                    class="w-16 h-16 bg-gradient-to-br from-[#bd925f] to-[#a0845a] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-8 h-8 text-white drop-shadow-sm"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path
                        d="M7 4h10l1 2h3v2h-2l-2.68 9.39A2 2 0 0 1 14.39 20H8.61a2 2 0 0 1-1.93-1.61L4 8H2V6h3l2-2Zm2.24 2-1 2h7.52l-1-2H9.24ZM8.61 18h5.78l2-8H6.61l2 8Z"
                      />
                    </svg>
                  </div>
                  <div class="flex-1 text-left">
                    <div class="text-lg font-bold text-[#341100] mb-1">
                      Take Away
                    </div>
                    <div class="text-xs text-[#8b6f3e] leading-relaxed">
                      Pesan dan jemput makanan Anda kemudian.
                    </div>
                  </div>
                </div>
              </button>

              <!-- Dine-in Button -->
              <button
                class="group w-full bg-white backdrop-blur-sm rounded-3xl shadow-md hover:shadow-lg transition-all duration-300 active:scale-[0.98] overflow-hidden border border-gray-100"
                @click="chooseDineIn"
              >
                <div class="flex items-center gap-4 p-5">
                  <div
                    class="w-16 h-16 bg-gradient-to-br from-[#bd925f] to-[#a0845a] rounded-2xl flex items-center justify-center flex-shrink-0 shadow-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-8 h-8 text-white drop-shadow-sm"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path
                        d="M3 11h8V3H3v8zm2-6h4v4H5V5zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4z"
                      />
                      <rect
                        x="13"
                        y="13"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="15"
                        y="15"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="13"
                        y="17"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="15"
                        y="19"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="17"
                        y="13"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="19"
                        y="15"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="17"
                        y="17"
                        width="2"
                        height="2"
                      />
                      <rect
                        x="19"
                        y="19"
                        width="2"
                        height="2"
                      />
                    </svg>
                  </div>
                  <div class="flex-1 text-left">
                    <div class="text-lg font-bold text-[#341100] mb-1">
                      Dine-in
                    </div>
                    <div class="text-xs text-[#8b6f3e] leading-relaxed">
                      Scan Barcode dan Pesan Menu langsung di tempat.
                    </div>
                  </div>
                </div>
              </button>
            </div>

            <!-- Info Card Section -->
            <div
              class="mt-6 bg-white/50 backdrop-blur-sm rounded-2xl p-4 border border-white/80"
            >
              <p class="text-xs text-center text-[#8b6f3e] leading-relaxed">
                Anda dapat mengganti pilihan dengan scan ulang QR Code di meja
                atau di kasir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- Fixed Footer at Bottom -->
    <footer
      class="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-t from-white via-white/95 to-transparent backdrop-blur-md border-t border-[#ecf0f1] shadow-2xl shadow-black/5"
    >
      <div class="w-full px-6 py-4">
        <div class="flex flex-col items-center gap-2.5">
          <!-- Professional Copyright Text -->
          <div class="text-center">
            <p class="text-xs font-medium text-[#341100]">
              © 2025 Sejadikopi . All rights reserved.
            </p>
            <p class="text-xs text-[#8b6f3e] mt-0.5">
              Designed & Developed by
              <span class="font-semibold text-[#341100]">RPL Team</span>
            </p>
          </div>

          <!-- Logo Divider -->
          <div class="flex items-center gap-3">
            <img
              src="https://sejadikopi-api-v2.sejadikopi.com/storage/Logo/sejadikopi_logo.png"
              alt="Sejadikopi Logo"
              class="h-5 w-auto opacity-60"
              draggable="false"
            >
            <div class="w-1 h-4 bg-[#e8d5c4]" />
            <img
              src="https://sejadikopi-api-v2.sejadikopi.com/storage/Logo/logo_rpl.png"
              alt="RPL Logo"
              class="h-5 w-auto opacity-60"
              draggable="false"
            >
          </div>
        </div>
      </div>
    </footer>

    <!-- Sidebar Backdrop -->
    <Teleport to="body">
      <transition
        name="sidebar-fade"
        mode="out-in"
      >
        <div
          v-if="showMenu"
          key="backdrop"
          class="fixed inset-0 z-[9998] bg-black/50 backdrop-blur-sm"
          @click="closeSidebar"
        />
      </transition>
    </Teleport>

    <!-- Sidebar -->
    <Teleport to="body">
      <transition
        name="sidebar-slide"
        mode="out-in"
      >
        <div
          v-if="showMenu"
          key="sidebar"
          class="fixed top-0 left-0 h-full w-80 bg-gradient-to-b from-[#1e1e1f] via-[#2d2d30] to-[#1e1e1f] shadow-2xl z-[9999] flex flex-col border-r border-[#ffffff]/10"
        >
          <!-- Header Sidebar -->
          <div
            class="flex items-center justify-between p-6 border-b border-[#ffffff]/10"
          >
            <div class="flex items-center gap-3 flex-1 min-w-0">
              <div class="relative">
                <img
                  src="https://sejadikopi-api-v2.sejadikopi.com/storage/Logo/sejadikopi_circle.png"
                  alt="Sejadikopi logo"
                  class="w-12 h-12 rounded-full border-2 border-[#74b9ff]/30 shadow-lg flex-shrink-0"
                >
                <div
                  class="absolute inset-0 rounded-full bg-gradient-to-br from-[#74b9ff]/20 to-transparent animate-pulse"
                />
              </div>
              <div class="flex-1 overflow-hidden min-w-0">
                <h2 class="text-base font-semibold text-white truncate">
                  Sejadikopi
                </h2>
                <p class="text-xs text-[#b2bec3] truncate">
                  Pool & Cafe
                </p>
              </div>
            </div>
            <button
              class="w-9 h-9 flex items-center justify-center rounded-xl hover:bg-[#ffffff]/10 text-[#b2bec3] hover:text-white transition-all flex-shrink-0"
              @click="closeSidebar"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Menu Items -->
          <div class="flex-1 p-6 space-y-3">
            <button
              class="group w-full px-5 py-4 rounded-2xl bg-gradient-to-br from-[#2d3436] via-[#34495e] to-[#2c3e50] hover:from-[#34495e] hover:via-[#405873] hover:to-[#2d3436] text-white font-medium text-sm transition-all duration-200 flex items-center gap-3 shadow-lg hover:shadow-xl active:scale-95 border border-[#ffffff]/5 relative overflow-hidden"
              @click="goToAbout"
            >
              <div
                class="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700"
              />
              <svg
                class="w-5 h-5 relative z-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span class="relative z-10">Tentang</span>
            </button>

            <button
              class="group w-full px-5 py-4 rounded-2xl bg-[#2d2d30]/50 hover:bg-[#2d2d30] text-[#b2bec3] hover:text-white font-medium text-sm transition-all duration-200 flex items-center gap-3 active:scale-95 border border-[#ffffff]/5"
              @click="goToContact"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <span>Kontak</span>
            </button>
          </div>

          <!-- Footer Sidebar -->
          <div class="p-6 border-t border-[#ffffff]/10">
            <div class="flex items-center justify-center gap-2">
              <span class="text-xs text-[#b2bec3] font-medium">Powered by</span>
              <img
                src="https://sejadikopi-api-v2.sejadikopi.com/storage/Logo/logo_rpl.png"
                alt="RPL Logo"
                class="h-5 w-auto opacity-70"
                draggable="false"
              >
            </div>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "OrderType",
  data() {
    return {
      showMenu: false,
      isAnimating: false,
      isCafeOpen: null,
      loadingStatus: true,
      realtimeChannel: null,
    };
  },
  async mounted() {
    console.log("Ordertype mounted - checking cafe status...");
    await this.checkCafeStatus();
  },
  beforeUnmount() {
    // Ensure menu is closed before unmounting
    this.showMenu = false;
    if (this.realtimeChannel) {
      supabase.removeChannel(this.realtimeChannel);
    }
  },
  methods: {
    async checkCafeStatus() {
      try {
        console.log("Fetching cafe status from API...");
        try {
          const response = await api.get("/settings");
          console.log("Cafe status from API:", response.data);
          this.isCafeOpen = response.data.is_open;
          console.log("Set isCafeOpen to:", this.isCafeOpen);

          // If cafe is closed, redirect to CafeClosed page
          if (!this.isCafeOpen) {
            console.log("Cafe is closed, redirecting to CafeClosed page...");
            this.loadingStatus = false;
            await this.$router.replace({ name: "CafeClosed" });
            return;
          }
        } catch (error) {
          console.error("Error fetching cafe status:", error);
          this.isCafeOpen = true;
        } finally {
          this.loadingStatus = false;
          console.log("Loading finished. isCafeOpen:", this.isCafeOpen);
        }
      } catch (error) {
        console.error("Unexpected error:", error);
        this.isCafeOpen = true;
        this.loadingStatus = false;
      }
    },

    chooseDineIn() {
      if (!this.isCafeOpen) return;

      localStorage.setItem("orderMode", "dine-in");
      localStorage.removeItem("receiverName");
      localStorage.removeItem("pickupTime");

      const chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let hash = "";
      for (let i = 0; i < 64; i++) {
        hash += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      localStorage.setItem("sessionHash", hash);

      this.$router.push({ name: "SelectLocation" });
    },

    chooseTakeaway() {
      if (!this.isCafeOpen) return;

      localStorage.setItem("orderMode", "take-away");
      localStorage.removeItem("tableNumber");

      const chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let hash = "";
      for (let i = 0; i < 64; i++) {
        hash += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      localStorage.setItem("sessionHash", hash);

      this.$router.push({ name: "SelectName" });
    },

    toggleMenu() {
      if (this.isAnimating) return;
      this.isAnimating = true;
      this.showMenu = !this.showMenu;
      setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    },
    closeSidebar() {
      if (this.isAnimating) return;
      this.isAnimating = true;
      this.showMenu = false;
      setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    },
    goToAbout() {
      if (this.isAnimating) return;
      this.showMenu = false;
      this.$router.push({ name: "AboutPage" });
    },
    goToContact() {
      if (this.isAnimating) return;
      this.showMenu = false;
      this.$router.push({ name: "ContactPage" });
    },
  },
};
</script>

<style scoped>
/* Fade In Animation */
.animate-fade-in {
  animation: fadeIn 0.7s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Backdrop Blur */
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.backdrop-blur-md {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.backdrop-blur-xl {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.backdrop-blur-2xl {
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
}

/* Sidebar Animations */
.sidebar-fade-enter-active,
.sidebar-fade-leave-active {
  transition: opacity 0.3s ease;
}

.sidebar-fade-enter-from,
.sidebar-fade-leave-to {
  opacity: 0;
}

.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  transform: translateX(-100%);
}
</style>
